export default (state = [], action) => {
  switch (action.type) {
    case 'FETCH_PREORDER_DETAIL':
      return [ ...state, ...action.payload ] || false
    default:
      return state
  }
}